module.exports = __webpack_public_path__ + "static/ostrava-poruba-d63c4979516aca40f835b4f29acb97e6.png";